import React from 'react';
import { Card } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Tooltip, IconButton } from '@mui/material';
import { FakeText } from '@totalsoft/rocket-ui';
import EngineScoringKnockoutCriteriaListComponent from './EngineScoringKnockoutCriteriaListComponent';
import PropTypes from 'prop-types';
import { Person, Add } from '@mui/icons-material';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const EngineScoringKnockoutCriteriaListContainer = ({
  knockoutCriteria,
  onSave,
  containerDispatcher,
  isReadOnly,
  validation,
  loading,
  dictionaryKnockoutCriteria
}) => {
  const { t } = useTranslation();

  const onAddNewKnockoutCriterion = () => {
    containerDispatcher({
      type: 'OnAddNewKnockoutCriterion'
    });
  };

  return loading ? (
    <FakeText lines={10} />
  ) : (
    <Card
      icon={Person}
      iconColor='primary'
      title={t('EngineScoring.EngineScoringKnockoutCriteria.Title')}
      actions={
        <Tooltip title={t('Tooltips.Add')}>
          <IconButton color='primary' onClick={onAddNewKnockoutCriterion} disabled={isReadOnly}>
            <Add />
          </IconButton>
        </Tooltip>
      }
    >
      <CardNoResultsWrapper content={knockoutCriteria}>
        <EngineScoringKnockoutCriteriaListComponent
          dispatch={containerDispatcher}
          knockoutCriteria={knockoutCriteria}
          dictionaryKnockoutCriteria={dictionaryKnockoutCriteria}
          isReadOnly={isReadOnly}
          loading={loading}
          onSave={onSave}
          validation={validation}
        />
      </CardNoResultsWrapper>
    </Card>
  );
};

EngineScoringKnockoutCriteriaListContainer.propTypes = {
  knockoutCriteria: PropTypes.array.isRequired,
  containerDispatcher: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  dictionaryKnockoutCriteria: PropTypes.array.isRequired
};

export default EngineScoringKnockoutCriteriaListContainer;
